import { createSlice } from "@reduxjs/toolkit";
// const storedUser = (sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user"))) || (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))) || null;

const initialState = {
  user: null,
  askSignup: false,
  guest: false,
  askTicket: true,
  homeModal: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, actions) => {
      state.user = actions.payload;
      sessionStorage.setItem("user", JSON.stringify(actions.payload));
      localStorage.setItem("user", JSON.stringify(actions.payload));
    },
    setHomeModal: (state) => {
      state.homeModal = true;
    },
    unSetHomeModal: (state) => {
      state.homeModal = false;
    },
    setAskTicket: (state) => {
      state.askTicket = true;
    },
    resetAskTicket: (state) => {
      state.askTicket = false;
    },
    setSignup: (state) => {
      state.askSignup = true;
    },
    resetAskSignup: (state) => {
      state.askSignup = false;
    },
    setGuest: (state) => {
      state.guest = true;
    },
    resetGuest: (state) => {
      state.guest = false;
    },
    logoutUser: (state) => {
      state.user = null;
      sessionStorage.removeItem("user");
      localStorage.removeItem("user");
      state.guest = false;
      state.askSignup = false;
      state.askTicket = true;
    },
  },
});

export const { setHomeModal, unSetHomeModal, setUser, setAskTicket, resetAskTicket, setSignup, resetAskSignup, setGuest, resetGuest, logoutUser } = userSlice.actions;

export default userSlice.reducer;
